import React, { FC } from "react";
import { DEMO_CAR_LISTINGS } from "data/listings";
import { CarDataType } from "data/types";
//import Pagination from "shared/Pagination/Pagination";
import FleetsCard2 from "./FleetsCard2";
// import FixedDepartureCard from "containers/FixedDeparturePage/components/FixedDepartureCard";


export interface SectionGridFilterCardProps {
  className?: string;
  data?: CarDataType[];
}

const DEMO_DATA: CarDataType[] = DEMO_CAR_LISTINGS.filter((_, i) => i < 12);

const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  data = DEMO_DATA,
}) => {
  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
      
    >

      {/* <LoadingOverlay /> */}
      <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {(data as any)?.map((car: any) => {
          return <FleetsCard2 key={car.id} data={car} size="small" />
        })}

      </div>

    </div>
  );
};

export default SectionGridFilterCard;
